export default {
    BackendUrl: process.env.VUE_APP_BACKEND_API_BASE_URL,
    DocsUrl: process.env.VUE_APP_DOCS_URL,
    APIClientPython: "https://github.com/cvr-dev/cvr.dev-python",
    APIClientGo: "https://github.com/cvr-dev/cvr.dev-go",
    PlausibleDataDomain: process.env.VUE_APP_PLAUSIBLE_DATA_DOMAIN,
    VirkTermsAndConditionsUrl: "https://datacvr.virk.dk/artikel/vilkaar-og-betingelser#accordion-5-button",

}
